import type { ReactNode } from 'react';

import type { ToolbarColors, ToolbarPlacement } from './context';
import type { NativeStackNavigationOptions } from '../../../react-navigation/native-stack';

/**
 * Default/web noop. On iOS, the `.ios.tsx` variant converts children to
 * `unstable_headerLeftItems`/`unstable_headerRightItems`. On Android, the
 * `.android.tsx` variant renders native Compose components via `headerLeft`/`headerRight`.
 */
export function processHeaderItemsForPlatform(
  _children: ReactNode,
  _placement: ToolbarPlacement,
  _colors?: ToolbarColors
): NativeStackNavigationOptions | null {
  return null;
}
